import { SET_DEALER_SETTINGS, SET_AMENITIES } from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.dealerSettings, action) {
  switch (action.type) {
    case SET_DEALER_SETTINGS:
      return action.payload;
    case SET_AMENITIES:
      return { ...state, amenities: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/dealerSettings/reducer.js